/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SamplesInputs */

const en_nav_samples = /** @type {(inputs: Nav_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samples`)
};

const es_nav_samples = /** @type {(inputs: Nav_SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestras`)
};

/**
* | output |
* | --- |
* | "Samples" |
*
* @param {Nav_SamplesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_samples = /** @type {((inputs?: Nav_SamplesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SamplesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_samples(inputs)
	return es_nav_samples(inputs)
});